import { inject } from 'vue'
import { bPaginationKey } from '@bigin/tokens'

export const usePagination = () => inject(bPaginationKey, {})
